import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import DataPlatform from '@app/model/_common/DataPlatform';
import DataProvider from '@app/model/_common/DataProvider';
import { BookingPositionState, BookingScanCity } from '../model/BookingPositionState';
import {
	FIND_BOOKING_POSITION_STATE_FOR_PERIOD_QUERY,
	FIND_BOOKING_SCAN_CITY_QUERY,
} from './BookingPositionGraphQLQueries';

export type BookingPositionInput = {
	companyHotelId: number,
	channel: DataProvider,
	// ISO 3166 code of the guest country (one of the countries that the admin set for the Scan city)
	country: string,
	device: DataPlatform.WEB | DataPlatform.MOBILE,
};

export default class BookingPositionService {
	public static findScanCity(companyHotelId: number) {
		return GraphQLExecutor.execute<BookingScanCity | null>(FIND_BOOKING_SCAN_CITY_QUERY, { companyHotelId });
	}

	public static findStateForPeriod(input: BookingPositionInput) {
		return GraphQLExecutor.execute<BookingPositionState>(FIND_BOOKING_POSITION_STATE_FOR_PERIOD_QUERY, input);
	}
}
